import type {VehicleFacebookPlatformAdvertisingAttribute} from './VehicleFacebookPlatformAdvertisingAttribute';

export type VehicleFacebookPlatformAdvertisingSettings = {
  platformCode: VehicleFacebookPlatformAdvertisingSettings.platformCode;
  enabled: boolean;
  attributes: Array<VehicleFacebookPlatformAdvertisingAttribute>;
  hasOverrides: boolean;
  updatedAt: string | null;
  updatedBy: string | null;
};

export namespace VehicleFacebookPlatformAdvertisingSettings {
  export enum platformCode {
    FACEBOOK = 'facebook',
  }
}
